module.exports = __webpack_public_path__ + "img/ban.671ad0af.png";